const NodeState = Object.freeze({
  UNCHECKED: "unchecked",
  CHECKED: "checked",
  INDETERMINATE: "indeterminate",
});

export default NodeState;
